import { Permission } from '@bookora/shared';

import type { TourDef } from './types';

const hasTab = (search: string, tab: string): boolean =>
  new URLSearchParams(search).get('tab') === tab;

/**
 * «ساعات کاری» — a tab of `/settings` (`?tab=hours`; the onboarding checklist's
 * `/settings/schedule` redirects here). Each colleague's week is edited on
 * `/staff/:id/working-hours` through the row's «ویرایش برنامه»; «یک برنامه
 * برای چند کارمند» (settings.edit) applies one week to several people at once.
 */
export const WORKING_HOURS_TOUR: TourDef = {
  key: 'working-hours',
  version: 1,
  surface: 'page',
  title: 'ساعت کاری',
  hubDescription: 'برنامهٔ هفتگی هر کارمند، یا یک برنامه برای چند نفر.',
  offer: {
    body: 'در دو قدم کوتاه نشونتون می‌دیم ساعت کاری کارکنان کجا تنظیم می‌شه. نوبت فقط در همین ساعت‌ها داده می‌شه.',
  },
  route: {
    path: '/settings?tab=hours',
    match: (pathname, search) => pathname === '/settings' && hasTab(search, 'hours'),
  },
  requires: { all: [Permission.SETTINGS_VIEW] },
  autoOffer: true,
  maxSteps: 2,
  minSteps: 2,
  steps: [
    {
      id: 'bulk',
      anchor: 'hours.bulk',
      placement: 'bottom-end',
      requires: { all: [Permission.SETTINGS_EDIT] },
      title: 'یک برنامه برای چند نفر',
      body: 'اگر چند کارمند ساعت کاری یکسانی دارن، برنامه رو یک بار تنظیم کنید و برای همه اعمال کنید.',
    },
    {
      id: 'edit',
      anchor: 'hours.edit',
      placement: 'auto',
      title: 'برنامهٔ هر کارمند',
      body: 'روزها و ساعت‌های شیفت هر کارمند رو با «ویرایش برنامه» جدا تنظیم کنید. نوبت، از جمله نوبت آنلاین، فقط در همین ساعت‌ها داده می‌شه.',
    },
  ],
};
